import { z } from 'zod';
import { PassFailWithNull } from '@/utils/common';

export const baseSocFormSchema = z.object({
    timingSec: z.number().min(0).nullable().optional(),
    result: z.enum(PassFailWithNull).nullable().optional(),
    date: z.date(),
});

export const createSocFormSchema = baseSocFormSchema
    .extend({
        userId: z.string().min(1, { message: 'Trainee is required' }),
        assessmentRunId: z.string().nullable().optional(),
        isTiedToAssessmentRun: z.boolean(),
    })
    .refine(data => !(data.isTiedToAssessmentRun && !data.assessmentRunId), {
        message: 'Assessment run is required when tying to an assessment run',
        path: ['assessmentRunId'],
    });

export type CreateSocFormData = z.infer<typeof createSocFormSchema>;

export type EditSocFormData = z.infer<typeof baseSocFormSchema> & {
    timingSecMinutes?: number | null;
    timingSecSeconds?: number | null;
    assessmentRunId?: string | null;
    isTiedToAssessmentRun?: boolean;
};

export const socDefaultFormValues: CreateSocFormData = {
    timingSec: null,
    result: null,
    date: new Date(),
    assessmentRunId: null,
    userId: '',
    isTiedToAssessmentRun: false,
};
